import { watch } from 'vue'

import { notification } from '@/lib/helpers'
import { useErrorStore } from '@/stores/error.stores'

export function useErrorNotification() {
  const errorStore = useErrorStore()

  watch(
    () => errorStore.currentError,
    (currentError) => {
      if (currentError?.isGlobal === false) {
        notification.error(currentError.message)
        errorStore.clearError()
      }
    },
  )
}
